import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    autoOpen: { type: Boolean, default: false }
  }

  connect () {
    if (this.autoOpenValue) {
      this.#autoOpenModal()
    }
  }

  #autoOpenModal () {
    const modalOpener = this.element.querySelector('[data-turbo-frame="modal"]')
    if (modalOpener) {
      modalOpener.click()
    }
  }
}
